const actions = {
    SET_USER: 'SET_USER',
    setUser: (payload) => ({
      type: actions.SET_USER,
      payload
    }),
  };
  export default actions;
  